<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2948 7.36678L8.16816 13.4934C7.4176 14.244 6.39962 14.6657 5.33816 14.6657C4.27671 14.6657 3.25872 14.244 2.50816 13.4934C1.7576 12.7429 1.33594 11.7249 1.33594 10.6634C1.33594 9.60199 1.7576 8.58401 2.50816 7.83344L8.63483 1.70678C9.1352 1.2064 9.81386 0.925293 10.5215 0.925293C11.2291 0.925293 11.9078 1.2064 12.4082 1.70678C12.9085 2.20715 13.1896 2.88581 13.1896 3.59344C13.1896 4.30108 12.9085 4.97973 12.4082 5.48011L6.27483 11.6068C6.02464 11.857 5.68531 11.9975 5.3315 11.9975C4.97768 11.9975 4.63835 11.857 4.38816 11.6068C4.13797 11.3566 3.99742 11.0173 3.99742 10.6634C3.99742 10.3096 4.13797 9.9703 4.38816 9.72011L10.0482 4.06678"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
